"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const ModalContainer_1 = require("../Modal/ModalContainer");
function Drawer({ isOpen, onClose, children }) {
    return ((0, jsx_runtime_1.jsx)(ModalContainer_1.ModalContainer, Object.assign({ isOpen: isOpen, onClose: onClose }, { children: ({ active }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('w-[544px]', 'max-w-[90%]', 'bg-white', 'relative', 'transition-all', 'duration-300', {
                'opacity-0 translate-x-28': !isOpen || !active,
                'opacity-100 translate-x-0 delay-[150ms] duration-300': isOpen && active,
            }) }, { children: children }))) })));
}
exports.Drawer = Drawer;
//# sourceMappingURL=Drawer.js.map